import { createContext } from 'react';
import type { SupplyPoint } from '@/features/supply-points/services/schemas';

export interface SupplyPointContextValue {
  supplyPoints: SupplyPoint[];
  activeSupplyPoint: SupplyPoint | null;
  setActiveSupplyPointId: (id: number) => void;
}

export const SupplyPointContext = createContext<SupplyPointContextValue>({
  supplyPoints: [],
  activeSupplyPoint: null,
  setActiveSupplyPointId: () => {
    throw new Error('setActiveSupplyPointId was called outside of SupplyPointProvider!');
  },
});
